module.exports = __webpack_public_path__ + "img/pattern3.286180c.svg";